import React from 'react';
import { MyHeader, Paragraph, Container, ContainerPadding, Fz20Bold } from '@/css/style';
import { useParams } from 'react-router-dom';
import { useNoticeReadQuery } from '@/services/boardService';
import { format, parse } from 'date-fns';
import { editBoardContentImg } from '@/utils/helper';

function Notice() {
    const param = useParams();
    const { data: noticeData } = useNoticeReadQuery(param.id);
    return (
        <Container>
            <MyHeader>
                <div>
                    <Fz20Bold $mb="1.538rem">{noticeData?.data.title}</Fz20Bold>
                    <span>
                        {' '}
                        {noticeData?.data.created &&
                            format(
                                parse(
                                    noticeData?.data.created,
                                    "yyyy-MM-dd'T'HH:mm:ss.SSSX",
                                    new Date()
                                ),
                                'yyyy. MM. dd'
                            )}
                    </span>
                </div>
            </MyHeader>
            <ContainerPadding>
                {/* <Paragraph $col="#000" $fz="1.154rem"> */}
                <div
                    dangerouslySetInnerHTML={{
                        __html: editBoardContentImg(
                            noticeData?.data.body ? noticeData?.data.body : ''
                        ),
                    }}
                />
                {/* </Paragraph> */}
                {/* <PostImg>
                    <img src="https://talkimg.imbc.com/TVianUpload/tvian/TViews/image/2021/01/20/8fc8a78a-70c1-45d9-98b0-4a70c4629a12.jpg" />
                </PostImg> */}
            </ContainerPadding>
        </Container>
    );
}

export default Notice;
